import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./equipment-assignment-list.html?ngResource";
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PickListModule } from 'primeng/picklist';
import { CommonModule } from '@angular/common';
import { InputTextModule } from 'primeng/inputtext';
import { FormsModule } from '@angular/forms';
import { equipmentPrettyType } from 'src/core/utils/filters';
let EquipmentAssignmentListComponent = class EquipmentAssignmentListComponent {
    sourceEq = [];
    targetEq = [];
    onSourceChange = new EventEmitter();
    onTargetChange = new EventEmitter();
    originalSourceEq;
    originalTargetEq;
    ngOnInit() {
        this.originalSourceEq = [...this.sourceEq];
        this.originalTargetEq = [...this.targetEq];
    }
    ngOnChanges(changes) {
        if (changes.sourceEq && !changes.sourceEq.firstChange) {
            this.originalSourceEq = [...this.sourceEq];
        }
        if (changes.targetEq && !changes.targetEq.firstChange) {
            this.originalTargetEq = [...this.targetEq];
        }
    }
    getPrettyName(item) {
        return equipmentPrettyType(item.equipmentType);
    }
    onSourceFilter(event) {
        const query = event.target.value.toLowerCase();
        this.sourceEq = this.getFilteredItems(this.originalSourceEq, query, true);
    }
    onTargetFilter(event) {
        const query = event.target.value.toLowerCase();
        this.targetEq = this.getFilteredItems(this.originalTargetEq, query, false);
    }
    getFilteredItems(items, query, fromSourceList) {
        return items.filter(item => item.name.toLowerCase().includes(query) ||
            item.equipmentType.toLowerCase().includes(query) ||
            (fromSourceList ? item.fromSourceList : item.fromTargetList));
    }
    applyStylingToItem(item, movingToSource, movingToTarget) {
        const isMovingBack = (movingToSource && item.fromTargetList) || (movingToTarget && item.fromSourceList);
        item.fromSourceList = movingToSource && !isMovingBack;
        item.fromTargetList = movingToTarget && !isMovingBack;
        item.className = isMovingBack ? '' : 'dirty-item';
    }
    onMoveAllToSource(event) {
        event.items.forEach((item) => this.applyStylingToItem(item, true, false));
        this.onSourceChange.emit(event);
    }
    onMoveAllToTarget(event) {
        event.items.forEach((item) => this.applyStylingToItem(item, false, true));
        this.onTargetChange.emit(event);
    }
    onMoveToSource(event) {
        event.items.forEach((item) => this.applyStylingToItem(item, true, false));
        this.onSourceChange.emit(event);
    }
    onMoveToTarget(event) {
        event.items.forEach((item) => this.applyStylingToItem(item, false, true));
        this.onTargetChange.emit(event);
    }
    static propDecorators = {
        sourceEq: [{ type: Input }],
        targetEq: [{ type: Input }],
        onSourceChange: [{ type: Output }],
        onTargetChange: [{ type: Output }]
    };
};
EquipmentAssignmentListComponent = __decorate([
    Component({
        selector: 'app-equipment-assignment-list',
        template: __NG_CLI_RESOURCE__0,
        standalone: true,
        imports: [PickListModule, CommonModule, InputTextModule, FormsModule]
    })
], EquipmentAssignmentListComponent);
export { EquipmentAssignmentListComponent };
